import { render, staticRenderFns } from "./BrandNewTeamSignup.vue?vue&type=template&id=8ea11b5e"
import script from "./BrandNewTeamSignup.vue?vue&type=script&lang=ts"
export * from "./BrandNewTeamSignup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports